function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "assets/badges/ic_badge_ur",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("rect", {
  id: "bounds",
  x: 0,
  y: 0,
  width: 48,
  height: 28
}), React.createElement("rect", {
  id: "background",
  fill: "#FB5607",
  x: 0,
  y: 0,
  width: 48,
  height: 28,
  rx: 14
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "m23.02,6.21v9.83c0,1.63-.51,2.93-1.53,3.88-1.02.95-2.42,1.42-4.19,1.42s-3.13-.46-4.15-1.38-1.55-2.19-1.57-3.8V6.21h3.08v9.85c0,.98.23,1.69.7,2.14.47.45,1.12.67,1.94.67,1.73,0,2.61-.91,2.64-2.73V6.21h3.09Z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "m31.07,15.67h-2.45v5.46h-3.08V6.21h5.55c1.76,0,3.12.39,4.08,1.18s1.44,1.9,1.44,3.33c0,1.02-.22,1.87-.66,2.55-.44.68-1.11,1.22-2,1.63l3.23,6.1v.14h-3.3l-2.8-5.46Zm-2.45-2.49h2.48c.77,0,1.37-.2,1.79-.59.42-.39.63-.93.63-1.62s-.2-1.26-.6-1.66-1.01-.6-1.84-.6h-2.47v4.48Z"
}));

const SvgIcBadgeUr = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "48px",
    height: "28px",
    viewBox: "0 0 48 28",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgIcBadgeUr, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_badge_ur.3acbdbcf.svg";
export { ForwardRef as ReactComponent };